


import axios from "axios";
import apiClient from "../../utils/apiclient";




export const craetebrandsonly=async(reqBody:{
   type: string;
   image_path: string,
   brand_name: string,
   brand_availbale_locations: string[],
   ten_pack_MRP_amount: string,
   twenty_pack_MRP_amount:string,
   status: string,
},token:string)=>{
  return await apiClient.post('/barnd_banner/craete_brand_banner_v1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}



export const getalllocations=async()=>{
   return await apiClient.get('/city/distinctcity',{
    
   })
}

export const craetebannersonly=async(reqBody:{
   type: string;
   image_path: string,
   banner_name: string,
   large_banner_image:string,
   banner_locations: string[],
   status: string,
},token:string)=>{
  return await apiClient.post('/barnd_banner/craete_brand_banner_v1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}




export const editbrandsonly=async(reqBody:{
   id:string,
   image_path: string[],
   brand_name: string,
   brand_availbale_locations: string[],
   ten_pack_MRP_amount: string,
   twenty_pack_MRP_amount:string,
},token:string)=>{
  return await apiClient.post('/barnd_banner/edit_brand_banner_v1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}

export const getbannerapprovalhistory=async(reqBody:{
   brand_banner_id: string,
},token:string)=>{
  return await apiClient.post('/barnd_banner/get_banner_approvalhistory_V1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}

export const editbannersonly=async(reqBody:{
   id:string,
   image_path: string,
   banner_name: string,
   large_banner_image:string,
   banner_locations: string[],
},token:string)=>{
  return await apiClient.post('/barnd_banner/edit_banner_v1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}



export const getapprovalhistoryofbrands=async(reqBody:{
   brand_banner_id:string,

},token:string)=>{
  return await apiClient.post('/barnd_banner/get_brandbanner_approval_history_v1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}

export const getbannerdetailsbyid=async(reqBody:{
   brand_banner_id:string,

},token:string)=>{
  return await apiClient.post('/barnd_banner/get_banner_details_by_id_V1',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}


export const getbrandsonly=async(reqBody:{
  search: string;
  created_date:string
  location:string
  page: string,
  limit:string
},token:string)=>{
 return await apiClient.post('/barnd_banner/get_brand_details_by_search_V1',reqBody,{
    headers:{
       Authorization: `Bearer ${token}`
    }
 })
}


export const getbannersonly=async(reqBody:{
  search: string;
  created_date:string
  location:string
  page: string,
  limit:string
},token:string)=>{
 return await apiClient.post('/barnd_banner/get_banner_details_by_search_v1',reqBody,{
    headers:{
       Authorization: `Bearer ${token}`
    }
 })
}



export const uploadimagebanner = async (file: File, token: string) => {
   const reqBody = new FormData();
   reqBody.append("answer", file); 
 
   return await apiClient.post("/answer/uploadfile", reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
       "Content-Type": "multipart/form-data", 
     },
   });
 };

 
 
 
 export const approvalhistory = async (p0: {}, token: string) => {
   return await apiClient.get('/barnd_banner/get_banner_details', {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
export const getdropdowncities=async()=>{
   return await apiClient.get('/city/distinctcity',{
     
   })
}



export const getbrandetails=async(token:string)=>{
   return await apiClient.get('/barnd_banner/get_brand_details',{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
}



export const getbrandbannerdetailsbyid=async(reqBody:{
   id: string;
 },token:string)=>{
   return await apiClient.post('/barnd_banner/get_brand_details_by_id_v1',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
}



export const get_banner_approvalhistory=async(reqBody:{
   id: string;
 },token:string)=>{
   return await apiClient.post('/barnd_banner/get_banner_approvalhistory_V1',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
}





export const uploadimage = async (formData: FormData, token: string) => {
   const headers = {
     Authorization: `Bearer ${token}`,
     "Content-Type": "multipart/form-data",
   };
 
   const response = await apiClient.post("/answer/uploadfile", formData, { headers });
   return response.data; 
 };
 
 